import { render, staticRenderFns } from "./Condiments.vue?vue&type=template&id=4995f4bc&"
import script from "./Condiments.vue?vue&type=script&lang=js&"
export * from "./Condiments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports